import { Component, EventEmitter, Output } from '@angular/core';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	Validators,
} from '@angular/forms';

import { messagesError } from './messages';

@Component({
	selector: 'app-subscription-data',
	templateUrl: './subscription-data.component.html',
	styleUrls: ['./subscription-data.component.scss'],
})
export class SubscriptionDataComponent {
	@Output() formIsValid = new EventEmitter();
	@Output() formContent = new EventEmitter();
	public currentPassword = '';
	private userData: any;
	private validateForm: boolean;

	private name: boolean;
	private email: boolean;
	private password: boolean;
	private passwordValue: string;

	public form: FormGroup = new FormGroup({
		name: new FormControl('', [
			Validators.required,
			Validators.minLength(6),
			Validators.maxLength(50),
			({ value }: AbstractControl) =>
				!value || value.trim().includes(' ') ? null : { shortName: true },
		]),
		email: new FormControl('', [Validators.required, Validators.email]),
	});

	constructor() {
		this.name = false;
		this.email = false;
		this.password = false;
	}

	setCurrentPassword(value) {
		this.currentPassword = value;
	}

	getErrorMessage(formControlName: string): string {
		const { errors, dirty, touched } = this.form.get(formControlName);
		if (!(dirty || touched) || !errors) return '';
		const error = Object.entries(errors)[0];
		return messagesError + `.${formControlName}.` + [error[0]] || '';
	}

	canSubmit(formControlName: string, input) {
		if (this.form.get(formControlName).valid && input.target.value) {
			this.activateSubmitBtn(input.target.value);
		} else {
			this.formIsValid.emit(true);
		}
	}

	activateSubmitBtn(value) {
		this.validateForm = this.form.valid;

		if (this.validateForm && value) {
			this.userData = [
				{
					name: this.form.controls.name.value,
					email: this.form.controls.email.value,
					password: this.form.controls.password.value,
				},
			];
			this.formIsValid.emit(true);
			this.formContent.emit(this.userData);
		}
	}
}
